/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [

  {
    url: "/actualites",
    name: "Tableau de bord",
    slug: "Tableau de bord",
    icon: "HomeIcon",
    i18n: "Tableau de bord",
    rule: ['SuperAdmin', 'Fournisseur', 'GestionnairePortail'],
  },
  {
    url: "/televente",
    name: "Commandes",
    slug: "Commandes",
    icon: "ShoppingBagIcon",
    i18n: "Commandes",
    rule: ['TeleCogepha'],
  },
  {
    url: "/telereclammation",
    name: "Réclamation",
    slug: "Réclamation",
    icon: "FolderPlusIcon",
    i18n: "Réclamation",
    rule: ['TeleCogepha'],
  },
  {
    url: '/f/analyse/ventes',
    name: "Analyse des ventes",
    slug: "Analyse des ventes",
    icon: "LineChartIcon",
    i18n: "Analyse des ventes",
    rule: ['Fournisseur'],

  },
  {
    url: null,
    name: "Vente",
    icon: "ShoppingBagIcon",
    i18n: "Vente",
    rule: ['Simple', 'SuperAdmin', 'Admin'],
    submenu: [
      {
        url: '/Commande/Nouveau',
        name: "Nouvelle Commande",
        slug: "vente-nouvelle",
        i18n: "Nouvelle Commande",
        icon: "HelpCircleIcon",
        rule: ['Simple', 'SuperAdmin', 'Admin'],
      },
      {
        url: '/Commande/Retours/nouveau',
        name: "Demande Retour",
        slug: "vente-retour",
        i18n: "Demande Retour",
        rule: ['Simple', 'SuperAdmin'],
      },
    ]
  },
  {
    url: null,
    name: "Historique",
    icon: "ArchiveIcon",
    i18n: "Historique",
    rule: ['Simple', 'Admin', 'SuperAdmin'],
    submenu: [
      {
        url: '/Commande/Mes-Commandes',
        name: "Mes Commandes",
        slug: "historique-commandes",
        i18n: "Mes Commandes",
        icon: "HelpCircleIcon",
        rule: ['Simple', 'Admin', 'SuperAdmin'],
      },
      {
        url: '/Commande/Mes-Retours',
        name: "Mes Retours",
        slug: "historique-retours",
        i18n: "Mes retours",
        icon: "HelpCircleIcon",
        rule: ['Simple', 'Admin', 'SuperAdmin'],
      },
    ]
  },
  {
    url: null,
    name: "Ged",
    icon: "BookIcon",
    i18n: "Documents",
    rule: ['SuperAdmin'],
    submenu: [
      {
        url: '/Commande/avoirs',
        name: "Mes Avoirs",
        slug: "historique-avoirs",
        i18n: "Mes Avoirs",
        rule: ['SuperAdmin'],
      },
      {
        url: '/bl/liste',
        name: "Mes BL",
        slug: "historique-bl",
        i18n: "Mes BL",
        rule: ['SuperAdmin'],
      },
      {
        url: '/facture/liste',
        name: "Mes Factures",
        slug: "historique-factures",
        i18n: "Mes Factures",
        rule: [],
      },
    ]
  },
  {
    url: null,
    name: "Ged",
    icon: "BookIcon",
    i18n: "Notifications",
    rule: ['SuperAdmin'],
    submenu: [
      {
        url: '/AllNotifications',
        name: "Mes Notifications",
        slug: "historique-notifications",
        i18n: "Mes Notifications",
        rule: ['SuperAdmin'],
      },
    ]
  },
  {
    url:'/client/journal',
    name:"Log Connexion",
    icon: "UsersIcon",
    slug:"Log Connexion",
    i18n:"Log Connexion",
    rule:['SuperAdmin'],
    
  },
  {
    url: "/Reclammation",
    name: "Réclamation",
    slug: "Réclamation",
    icon: "FolderPlusIcon",
    i18n: "Reclamation",
    rule: ['Simple', 'Admin', 'SuperAdmin', 'Fournisseur'],
  },
  {
    url: "/CirculaireClient",
    name: "Circulaires",
    slug: "Circulaires",
    icon: "FileTextIcon",
    i18n: "Circulaires",
    rule: ['SuperAdmin'],
  },
  {
    url: "/ArrivageClient",
    name: "Arrivages",
    slug: "Arrivages",
    icon: "FileTextIcon",
    i18n: "Arrivages",
    rule: ['SuperAdmin'],
  },
  {
    url: "/nouvelArticle",
    name: "Créations",
    slug: "Créations",
    icon: "FileTextIcon",
    i18n: "Créations",
    rule: ['SuperAdmin'],
  },
    /* {
     url: "/Catalogue/Shop",
     name: "Catalogue",
     slug: "Catalogue",
     icon: "GiftIcon",
     i18n: "Catalogue",
     rule: ['Simple', 'Admin', 'SuperAdmin'],
   },  */

  {
    url: null,
    name: "Gestion Articles",
    slug: "Gestion Articles",
    icon: "ListIcon",
    i18n: "Gestion Articles",
    rule: ['Fournisseur'],
    submenu: [
      {
        url: '/f/mesarticles',
        name: "Mes Articles",
        slug: "Mes Articles",
        i18n: "Mes Articles",
        rule: ['Fournisseur'],
      },
      {
        url: '/f/mesarticles/nouveau',
        name: "Nouvel Article",
        slug: "Nouvel Article",
        i18n: "Nouvel Article",
        rule: ['Fournisseur'],
      },
    ]
  },

  {
    url: null,
    name: "Ged",
    icon: "ArchiveIcon",
    i18n: "Documents",
    rule: ['Fournisseur'],//Fournisseur
    submenu: [
      {
        url: '/f/doc/historique',
        name: "Factures",
        slug: "Ged-aa",
        i18n: "Factures",
        rule: ['Fournisseur'], //Fournisseur
      },
      {
        url: '/f/doc/commandes',
        name: "Commandes",
        slug: "Ged-bb",
        i18n: "Commandes",
        rule: ['Fournisseur'],//Fournisseur
      },
    ]
  },
  // Gestion des notifications
  {
    url: null,
    name: "Ged",
    icon: "UsersIcon",
    i18n: "Notifications",
    rule: ['GestionnairePortail', 'GestionFournisseurPortail'],

    submenu: [
      {
        url: '/admin/notification/nouveau',
        name: "Modèle notifications",
        slug: "Modèle notifications",
        i18n: "Modèle notifications",
        rule: ['GestionnairePortail', 'GestionFournisseurPortail'],
      }, /* {
        url: '/admin/notification/backoffice',
        name: "BackOffice",
        slug: "BackOffice",
        i18n: "BackOffice",
        rule: ['GestionnairePortail'],
      }, */
      /* {
        url: '/admin/notification/historique',
        name: "Historique",
        slug: "Historique",
        i18n: "Historique",
        rule: ['GestionnairePortail'],
      }, */
    ]
  },
  // gestion potail 
  {
    url: null,
    name: "Ged",
    icon: "UsersIcon",
    i18n: "Gestion Comptes",
    rule: ['GestionnairePortail', 'GestionFournisseurPortail'],

    submenu: [
      {
        url: '/admin/fournisseurs',
        name: "Fournisseurs",
        slug: "Fournisseurs",
        i18n: "Fournisseurs",
        rule: ['GestionnairePortail', 'GestionFournisseurPortail'],
      }, {
        url: '/admin/clients',
        name: "Clients",
        slug: "Clients",
        i18n: "Clients",
        rule: ['GestionnairePortail'],
      },
      {
        url:'/journal',
        name:"Journal",
        slug:"Journal",
        i18n:"Journal",
        rule:['GestionnairePortail'],
      },

      {
        url: '/admin/gestionnaires/liste',
        name: "Admin",
        slug: "Admin",
        i18n: "Admin",
        rule: ['GestionnairePortail'],
      },

      {
        url: '/admin/Livreur',
        name: "Livreurs",
        slug: "Livreurs",
        i18n: "Livreurs",
        rule: ['GestionnairePortail'],
      },]
  }
  , {
    url: '/admin/vente',
    name: "Vente",
    slug: "Vente",
    i18n: "Vente",
    icon: "ArchiveIcon",
    rule: [], //'GestionnairePortail'
  },
  {
    url: "/admin/Reclammations",
    name: "Reclamations",
    slug: "Reclamations",
    icon: "BookmarkIcon",
    i18n: "Reclamations",
    rule: ['GestionnairePortail'],
  },
  {
    url: "/admin/Circulaire",
    name: "Circulaire",
    slug: "Circulaire",
    icon: "FileTextIcon",
    i18n: "Circulaire",
    rule: ['GestionnairePortail'],
  },
  /* {
    url: "/admin/arrivage",
    name: "Arrivage",
    slug: "Arrivage",
    icon: "FileTextIcon",
    i18n: "Arrivage",
    rule: ['GestionnairePortail'],
  }, */
  /* {
    url: "/admin/repartition",
    name: "Repartition",
    slug: "Repartition",
    icon: "FileTextIcon",
    i18n: "Repartition",
    rule: ['GestionnairePortail'],
  }, */
  /* {
    url: "/admin/manquant",
    name: "Manquant",
    slug: "Manquant",
    icon: "FileTextIcon",
    i18n: "Manquant",
    rule: ['GestionnairePortail'],
  }, */
  {
    url: "/admin/clients/stat",
    name: "Analyse et Statistique",
    slug: "Analyse et Statistique",
    icon: "ArchiveIcon",
    i18n: "Analyse et Statistique",
    rule: ['GestionnairePortail'],
  },
  // gestion potail 
  {
    url: null,
    name: "Ged",
    slug: "",
    icon: "ShoppingBagIcon",
    i18n: "Gestion Articles",
    rule: ['GestionnairePortail', 'GestionArticlePortail'],

    submenu: [
      {
        url: '/admin/articles',
        name: "Liste Articles",
        slug: "Liste Articles",
        icon: "Liste Articles",
        i18n: "Liste Articles",
        rule: ['GestionnairePortail', 'GestionFournisseurPortail'],
      },
      /* {
        url: '/admin/articles/nouveau',
        name: "Nouvelle Creation",
        slug: "Nouvelle Creation",
        icon: "Nouvelle Creation",
        i18n: "Nouvelle Création",
        rule: ['GestionnairePortail'],
      }, */
      {
        url: '/admin/articles/nouveau',
        name: "Créations",
        slug: "Créations",
        icon: "Créations",
        i18n: "Créations",
        rule: ['GestionnairePortail'],
      },
      {
        url: "/admin/arrivage",
        name: "Arrivages",
        slug: "Arrivages",
        icon: "Arrivages",
        i18n: "Arrivages",
        rule: ['GestionnairePortail'],
      },
    ]
  },

  {
    url: "/admin/fournisseurs/demande/compte",
    name: "Ged",
    slug: "",
    icon: "ShoppingBagIcon",
    i18n: "Création Fournisseur",
    rule: ['GestionnairePortail', 'GestionFournisseurPortail'],
  },
  {
    url: null,
    name: "Ged",
    slug: "",
    icon: "ActivityIcon",
    i18n: "Satisfaction client",
    rule: ['GestionnairePortail'],

    submenu: [
      {
        url: "/admin/client/satisfaction/global",
        name: "Ged",
        slug: "",
        icon: "ActivityIcon",
        i18n: "Rapport global",
        rule: ['GestionnairePortail'],
      },
      {
        url: "/admin/client/satisfaction/detaillee",
        name: "Ged",
        slug: "",
        icon: "ActivityIcon",
        i18n: "Analyse détaillée",
        rule: ['GestionnairePortail'],
      },
    ]
  },

]

